import { render, staticRenderFns } from "./MainMenuItem.vue?vue&type=template&id=836cbff6&scoped=true&"
import script from "./MainMenuItem.vue?vue&type=script&lang=js&"
export * from "./MainMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuItem.vue?vue&type=style&index=0&id=836cbff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836cbff6",
  null
  
)

export default component.exports